// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-configuration-block{margin-bottom:16px}.product-configuration-block .color-selector{position:relative;inset-inline-start:-10px}", ""]);
// Exports
module.exports = exports;
